export enum TicketLogChange {
    Replace = "replace",
    Remove = "remove",
    Add = "add",
    DeleteTicket = "delete_ticket",
    RecoveryTicket = "recovery_ticket",
    SolveTicket = "solve_ticket",
}